import { useEffect, useMemo, useState } from "react";
import {
  Table,
  Select,
  Modal,
  Button,
  Flex,
  Upload,
  message,
  Space,
  Popconfirm,
  Typography,
  Tooltip,
  Input,
  Card,
  Form,
  Row,
  Col,
  Spin,
} from "antd";
import {
  InboxOutlined,
  CloseOutlined,
  EditOutlined,
  DeleteOutlined,
  FilterOutlined,
  LoginOutlined,
} from "@ant-design/icons";

import { connect } from "react-redux";
import { decryptCredentials, downloadFileHandle } from "../../utils/commonFunc";
import UserEdit from "./UserEdit";
import axios from "axios";
import dayjs from "dayjs";
import {useLocation} from "react-router-dom";
import APIService from "../../services/APIService";

const { Dragger } = Upload;
const { Option } = Select;

function UsersList({ isLoading }) {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);
  const [isEditModal, setIsEditModal] = useState(false);
  const [editData, seteditData] = useState(null);
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [fileNames, setFileNames] = useState({});
  const [uploading, setUploading] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form2] = Form.useForm();
  const [filters, setFilters] = useState({});
  const [allUsers, setAllUsers] = useState([]);
  const [serverList, setServerList] = useState([]);
  const location = useLocation();
  const isLeads = location.pathname === '/make-my-profit/leads';
  const apiService = useMemo(() => new APIService({ baseURL: process.env.REACT_APP_ADMIN_API_URL, product: 'MAKE_MY_PROFIT' }), []);

  useEffect(() => {
    fetchList();
  },[filters,location]);
  
  useEffect(() => {
    fetchServerList()
  },[allUsers]);
  
  const fetchServerList = async () => {
    await apiService.get('/server/list')
      .then(res => {
        if(res.data) {
          setServerList(res.data)
        }
      })
      .catch(e => {
      message.error("Failed to fetch server list")
      console.log(e);
    })
  }

  const handleServerChange = async (serverId,rec) => {
    
    setLoading(true);
    try {
        await apiService.put('/server/assign-server', { userId: rec.key, serverId });
        message.success('Server assigned successfully');
        fetchList();
    } catch (error) {
        message.error(error?.response?.data?.message || 'Failed to assign server');
        console.error(error);
        fetchList();
    } finally {
        setLoading(false);
    }
  };

  const handleFileNameChange = (name, fileId) => {
    setFileNames((prev) => ({ ...prev, [fileId]: name }));
  };

  const columns = [
    {
      title: "#",
      dataIndex: "count",
      key: "count",
      fixed: "left",
      width: "50px",
    },
    {
      title: "Name",
      dataIndex: "fullname",
      fixed: "left",
      key: "fullname",
      width: "200px",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      fixed: "left",
      width: "250px",
    },
    {
      title: "Password",
      dataIndex: "password",
      key: "password",
      width: "150px",
    },
    {
      title: "User Code",
      dataIndex: "userCode",
      key: "userCode",
      width: "120px",
    },
    {
      title: "Bot",
      dataIndex: "bot",
      key: "bot",
      width: "100px",
    },
    {
      title: "Bot Status",
      key: "botStatus",
      dataIndex: "botStatus",
      render: (val, rec) => (
        <>
          <Flex align="center">
            <span
              style={{
                display: "inline-block",
                height: 10,
                minWidth: 10,
                width: 10,
                borderRadius: "50%",
                backgroundColor: `${val !== "INACTIVE" ? "#37ff21" : "#ff3b3b"}`,
                marginRight: 5,
              }}
            ></span>
            <Select
              value={val}
              style={{ width: "100%" }}
              onChange={(e) => changeBotStatus(e, rec)}
              options={[
                { value: "ACTIVE", label: "Activate" },
                { value: "INACTIVE", label: "Inactivate" },
              ]}
            />
          </Flex>
        </>
      ),
      width: "140px",
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (e, rec) => (
        <>
          <Select
            defaultValue={e}
            value={e}
            style={{ width: "100%" }}
            onChange={(val) => statusChange(val, rec)}
            options={[
              { value: "ACTIVE", label: "Activate" },
              { value: "INACTIVE", label: "Inactivate" },
            ]}
          />
        </>
      ),
      width: "140px",
    },
    (!isLeads && {
      title: "VPS Server",
      key: "vpsServer",
      width: "200px",
      render: (val, record) => {
        return (
            <Select
                style={{width: '100%'}}
                value={val.vpsServer}
                onChange={(serverId) => handleServerChange(serverId, record)}
                placeholder="Assign a server"
                loading={loading}
            >
                {serverList.map((server) => (
                    <Option key={server._id} value={server._id}>
                        {server.acName}
                    </Option>
                ))}
            </Select>
        )
      }
    }),
    {
      title: "Action",
      key: "action",
      dataIndex: "action",
      width: "140px",
      render: (e, rec) => (
        <Space>
          {/* <Button type="default" icon={<UploadOutlined />} size={"middle"} onClick={() => uploadOpen(rec)} /> */}
          <Tooltip title="Login">
            <Button type="default" icon={<LoginOutlined />} size={"middle"} onClick={() => loginHandle(rec)} />
          </Tooltip>
          <Button
            type="default"
            icon={<EditOutlined />}
            size={"middle"}
            onClick={() => {
              seteditData(rec);
              setIsEditModal(true);
            }}
          />
          <Popconfirm
            description="Are you sure you want to close this account ?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => deleteUser(rec.key)}
          >
            <Tooltip title="Deactivate account status to close this account">
              <Button
                icon={<CloseOutlined />}
                danger
                size={"middle"}
                // disabled={rec.record.botStatus || rec.record.user.status == "ACTIVE"}
              />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
    {
      title: "Phone number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      width: "140px",
    },
    // {
    //     title: "Address",
    //     dataIndex: "address",
    //     key: "address",
    //     width: "250px",
    // },
    {
      title: "Date of Birth",
      dataIndex: "dob",
      key: "dob",
      width: "140px",
    },
    {
      title: "Account Name",
      dataIndex: "accountName",
      key: "accountName",
      width: "200px",
    },
    {
      title: "Account Number",
      key: "accountNumber",
      dataIndex: "accountNumber",
      width: "200px",
    },
    {
      title: "Broker Name",
      dataIndex: "brokerName",
      key: "brokerName",
      width: "200px",
    },
    {
      title: "Server Name",
      dataIndex: "brokerServer",
      key: "serverName",
      width: "200px",
    },
    {
      title: "Master Password",
      dataIndex: "masterPassword",
      key: "masterPassword",
      width: "200px",
    },
    {
      title: "Investor Password",
      dataIndex: "investorPassword",
      key: "investorPassword",
      width: "200px",
    },
    {
      title: "Deposit Amount",
      dataIndex: "depositAmount",
      key: "depositAmount",
      width: "200px",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: "180px",
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      width: "180px",
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
      width: "180px",
    },
    // {
    //     title: "Product Name",
    //     dataIndex: "productName",
    //     key: "productName",
    //     width: "200px",
    // },
  ].filter(Boolean);

  const uploadOpen = (rec) => {
    setSelectedUser(rec);
    setIsUploadOpen(true);
    getUploadedFiles(rec);
  };

  const loginHandle = (rec) => {
    axios
      .get(`${process.env.REACT_APP_ADMIN_API_URL}admin/generate-token/${rec.key}`, {
        headers: {
          "x-product-type": "MAKE_MY_PROFIT",
        },
      })
      .then((res) => {
        const token = res.data.token;
        // window.open(`http://localhost:3001/dashboard?token=${token}`, "_blank");
        window.open(`https://my.makemyprofits.com/dashboard?token=${token}`, '_blank');
      })
      .catch((e) => {
        message.error(e.response?.data?.message || "Login failed");
        console.error(e);
      });
  };

  const statusChange = (val, rec) => {
    axios
      .post(
        `${process.env.REACT_APP_ADMIN_API_URL}admin/update-status`,
        {
          userId: rec?.key,
          status: val,
        },
        {
          headers: {
            "x-product-type": "MAKE_MY_PROFIT",
          },
        }
      )
      .then((res) => {
        message.success(res.data.message || "Status updated successfully!");
        fetchList({});
      })
      .catch((e) => message.error(e.message || "An error occurred"));
  };

  const changeBotStatus = (val, rec) => {
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_ADMIN_API_URL}admin/bot-status/${rec?.key}`,
        { botStatus: val },
        {
          headers: {
            "x-product-type": "MAKE_MY_PROFIT",
          },
        }
      )
      .then((res) => {
        message.success(res.data.message || "Status updated successfully!");
        fetchList({});
        setLoading(false);
      })
      .catch((e) => message.error(e.message || "An error occurred"));
  };

  const fetchList = () => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_ADMIN_API_URL}admin/approved-users?botStatus=${isLeads ? 'INACTIVE' : ''}`, {
        headers: {
          "x-product-type": "MAKE_MY_PROFIT",
        },
      })
      .then((res) => {
        const data = res.data.map((user, index) => {
          if (!user.hashedPassword || !user.salt) {
            console.warn(`⚠️ Missing hashedPassword or salt for User ${index + 1}:`, user);
          }
          const decryptedPassword = decryptCredentials(user?.salt, user?.hashedPassword);
          const investorPassword = decryptCredentials(user?.salt, user?.investorPassword);
          const masterPassword = decryptCredentials(user?.salt, user?.masterPassword);

          return {
            count: index + 1,
            key: user?._id,
            fullname: user?.fullName || "-",
            phoneNumber: user?.phoneNumber || "-",
            dob: user?.dob ? dayjs(user.dob).format("DD-MM-YYYY") : "-",
            email: user?.email || "-",
            loginRequestStatus: user?.loginRequestStatus,
            status: user?.status,
            botStatus: user?.botStatus,
            city: user?.city || "-",
            state: user?.state || "-",
            country: user?.country || "-",
            accountName: user?.accountName || "-",
            accountNumber: user?.accountNumber || "-",
            brokerName: user?.brokerName || "-",
            brokerServer: user?.brokerServer || "-",
            password: decryptedPassword || "-",
            investorPassword: investorPassword || "-",
            masterPassword: masterPassword || "-",
            userCode: user?.userCode || "-",
            depositAmount: user?.depositAmount || "-",
            bot: user?.mmpBot,
            vpsServer: user?.mmpVpsServer,
          };
        });

        setAllUsers(data);
        if (filters.botStatus) {
          const filteredData = data.filter((user) => user.botStatus === filters.botStatus);
          setUserList(filteredData);
        } else {
          setUserList(data);
        }
        setLoading(false);
      })
      .catch((error) => {
        message.error("Failed to fetch user list");
        console.error(error);
        setLoading(false);
      });
  };

  const deleteUser = (id) => {
    axios
      .delete(`${process.env.REACT_APP_ADMIN_API_URL}admin/delete-user/${id}`, {
        headers: {
          "x-product-type": "MAKE_MY_PROFIT",
        },
      })
      .then((res) => {
        fetchList({});
        message.success(res.message || "User Deleted");
      })
      .catch((e) => {
        message.error(e.message || "An error occurred");
      });
  };

  const fileListColumn = [
    {
      title: "Filename",
      key: "name",
      render: (file) => {
        const isExistingFile = !!file?._id;

        return (
          <Input
            defaultValue={file?.name || file?.fileName || "N/A"}
            readOnly={isExistingFile}
            onChange={(e) => !isExistingFile && handleFileNameChange(e.target.value, file.uid)}
          />
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, file) => (
        <Flex align="center" gap={10} justify="center">
          <DeleteOutlined onClick={() => handleDeleteFile(file)} style={{ color: "red" }} />
        </Flex>
      ),
    },
  ];

  const handleChange = ({ fileList }) => {
    setFileList(fileList);
  };

  const handleUpload = () => {
    if (fileList.length === 0) {
      message.warning("Please select a file to upload.");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("files", file.originFileObj);
      formData.append("fileNames", fileNames[file.uid] || file.name);
    });

    axios
      .post(`${process.env.REACT_APP_ADMIN_API_URL}admin/upload-file/${selectedUser?.key}`, formData, {
        headers: {
          "x-product-type": "MAKE_MY_PROFIT",
        },
      })
      .then(() => {
        message.success("Files uploaded successfully");
        setIsUploadOpen(false);
        setFileList([]);
        setFileNames({});
        getUploadedFiles(selectedUser);
        isLoading = false;
      })
      .catch((e) => message.error("File upload failed"))
      .finally(() => setUploading(false));
  };

  const getUploadedFiles = (rec) => {
    axios
      .get(`${process.env.REACT_APP_ADMIN_API_URL}admin/uploaded-files/${rec?.key}`, {
        headers: {
          "x-product-type": "MAKE_MY_PROFIT",
        },
      })
      .then((res) => {
        setExistingFiles(res.data.uploadedFiles || []);
      })
      .catch((e) => message.error("Error fetching uploaded files"));
  };

  const handleDeleteFile = (file) => {
    if (!file) {
      message.error("Invalid file.");
      return;
    }

    if (file.uid) {
      setFileList((prevList) => prevList.filter((f) => f.uid !== file.uid));
      message.success("File removed from upload queue.");
      return;
    }

    if (file._id && selectedUser?.key) {
      axios
        .delete(`${process.env.REACT_APP_ADMIN_API_URL}admin/delete-file/${selectedUser.key}/${file._id}`, {
          headers: {
            "x-product-type": "MAKE_MY_PROFIT",
          },
        })
        .then((res) => {
          message.success(res.data.message || "File deleted successfully");
          setExistingFiles((prevFiles) => prevFiles.filter((f) => f._id !== file._id));
        })
        .catch((error) => {
          message.error(error.response?.data?.error || "Failed to delete the file");
          console.error("Error deleting file:", error);
        });
    }
  };

  const filterHandle = (values) => {
    setLoading(true);
    const newFilters = {};
    if (values.botStatus) {
      newFilters.botStatus = values.botStatus;
    }
    setFilters(newFilters);
  };

  const resetFilter = () => {
    setLoading(true);
    form2.resetFields();
    setFilters({});
    setUserList(allUsers);
  };

  return (
    <Spin spinning={loading}>
      <Modal title="Upload File" open={isUploadOpen} onCancel={() => setIsUploadOpen(false)} footer={[]} width={600}>
        <Dragger fileList={fileList} onChange={handleChange} beforeUpload={() => false} showUploadList={false}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
          <p className="ant-upload-hint">
            Support for a single or bulk upload. Strictly prohibited from uploading company data or other banned files.
          </p>
        </Dragger>

        <Table
          columns={fileListColumn}
          dataSource={[...(existingFiles || []), ...(fileList || [])]}
          rowKey={(file) => file?._id || file?.uid || Math.random()}
          style={{ marginTop: 16 }}
        />

        <Button type="primary" onClick={handleUpload} loading={uploading} style={{ marginTop: "5px" }}>
          {uploading ? "Uploading..." : "Upload"}
        </Button>
      </Modal>
      <Typography.Title level={3} className="page-title">
        List
      </Typography.Title>

      <Flex justify="end" gap={5} style={{ marginBottom: "20px" }}>
        {/* <Input style={{ maxWidth: 200 }} placeholder="Search..." onChange={(e) => setSearchText(e.target.value)} /> */}
        <Button type="primary" onClick={() => setFilterShow(!filterShow)}>
          <FilterOutlined />
        </Button>
        {/* {(permission?.customer == "EDIT" || user?.role != "SUBADMIN") && <Button type="primary" onClick={showModal}>
                    Create User
                </Button>} */}
        <Button type="primary" onClick={() => downloadFileHandle(userList, "users")}>
          Download
        </Button>
      </Flex>
      {filterShow && (
        <Card style={{ marginBottom: "20px" }}>
          <Form form={form2} layout="vertical" onFinish={filterHandle}>
            <Row gutter={16}>
              <Col span={4}>
                <Form.Item name="botStatus">
                  <Select allowClear placeholder="Select Bot Status">
                    <Option value={"ACTIVE"}>Activate</Option>
                    <Option value={"INACTIVE"}>Inactivate</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col>
                <Space>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    Filter
                  </Button>
                  <Button type="default" onClick={resetFilter}>
                    Reset
                  </Button>
                </Space>
              </Col>
            </Row>
          </Form>
        </Card>
      )}
      <Table loading={isLoading} scroll={{ x: 2000 }} columns={columns} dataSource={userList} />
      {isEditModal && (
        <UserEdit editData={editData} isLoading={false} onClose={() => setIsEditModal(false)} fetchList={fetchList} />
      )}
    </Spin>
  );
}
const mapStateToProps = ({ loading }) => {
  const { isLoading } = loading;
  return { isLoading };
};
export default connect(mapStateToProps, {})(UsersList);
